import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { useSelector, useDispatch } from "react-redux";
import { selectSelected, editItem } from "./fssSlice";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../utility";
import { showSuccessDialog, showErrorDialog } from "../../utility";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
export const FssDetail = () => {
  const history = useHistory();
  const items = useSelector(selectSelected);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  // Return if data null
  if (items === null) {
    history.push("/fss-asm-bm");
  }
  const [qty, setQty] = useState("");

  const editAllowed = ["ADMIN", "SALES_SERVICE", "ADMINISTRATOR"];

  const role = user.roles.map((e) => {
    return e.roleName;
  });

  const checkRoles = (userRoles, allowedRoles) => {
    return userRoles.some((e) => allowedRoles.includes(e));
  };

  useEffect(() => {
    if (items !== null) {
      setQty(items.qty);
    }
  }, [items]);

  const handleSave = async () => {
    if (parseFloat(qty) > parseFloat(items.availableQty)) {
      return showErrorDialog(
        `Can't be bigger than available Qty ${items.availableQty}`
      );
    }
    if (parseFloat(qty) <= 0) {
      return showErrorDialog("can't be less than zero");
    }
    const id = items.returnDetailId;
    const params = {
      qty: qty,
    };
    try {
      const response = await dispatch(editItem({ id, params }));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        if (action.isConfirmed) history.push("/fss-asm-bm");
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return items === null ? null : (
    <Card>
      <CardHeader title="Fss Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.retNumber} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.invoiceNo} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Reason</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.reasonName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Cust Name</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.customerName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Created By</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.userName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Doc Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={formatDate(items.docDate)} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Name</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.clientName} />
                </Col>
              </Form.Group>
            </Col>
            {/* Row kiri */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.materialCode} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material Desc</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.materialName} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Rayon Type</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.rayonType} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Batch</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.batch} />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control disabled value={items.uom} />
                </Col>
              </Form.Group>
              {!checkRoles(role, editAllowed) && (
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Qty</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.qty} />
                  </Col>
                </Form.Group>
              )}
              {checkRoles(role, editAllowed) && (
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Qty</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setQty(e.target.value);
                      }}
                      value={qty}
                    />
                  </Col>
                </Form.Group>
              )}

              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Exp Date</b>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    disabled
                    value={formatDate(items.expiredDate)}
                  />
                </Col>
              </Form.Group>
            </Col>
            {/* end kiri */}
          </Form.Group>
        </Form>
        <Row className="mt-6">
          <Button
            variant="light"
            className="mr-3"
            onClick={() => history.push("/fss-asm-bm")}
          >
            <i className="fa fa-arrow-left" />
            Back
          </Button>
          {/* <Button
            variant="success"
            className="mr-3"
            onClick={() => handleSave()}
          >
            Save
          </Button> */}
        </Row>
      </CardBody>
    </Card>
  );
};
